import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const filterSerializer = (filters: string[]) => {
    let cookie = 'c6filter=';

    for (const filter of filters) {
        cookie += filter + ':';
    }

    document.cookie = cookie;
};

const delDupSerializer = (deldup: any) => {
    let cookie = 'c6deldup=';

    if (!deldup.del) {
        cookie += 'dup';
    } else if (!deldup.dup) {
        cookie += 'del';
    }

    document.cookie = cookie;
};

const filterDeserializer = document.cookie.match(/c6filter=((.*?:)+)/);
const deldupDeserializer = document.cookie.match(/c6deldup=(\w+)/);

export default new Vuex.Store({
    state: {
        filters: filterDeserializer !== null && filterDeserializer[1] ?
        filterDeserializer[1].split(':') : [] as string[],
        deldup: {
            del: deldupDeserializer !== null && deldupDeserializer[1] &&
            deldupDeserializer[1] === 'dup' ? false : true as boolean,
            dup: deldupDeserializer !== null && deldupDeserializer[1] &&
            deldupDeserializer[1] === 'del' ? false : true as boolean,
        },
    },
    getters: {
        filter: (state) => {
            return state.filters.length > 0 || !state.deldup.del || !state.deldup.dup;
        },
        blogfilter: (state) => {
            return state.filters.map((value) => {
                return '6' + value;
            });
        },
        has_filter: (state) => (filter: string) => {
            return state.filters.indexOf(filter) >= 0;
        },
    },
    mutations: {
        add_filter: (state, filter: string) => {
            if (state.filters.indexOf(filter) === -1) {
                state.filters.push(filter);
            }

            filterSerializer(state.filters);
        },
        remove_filter: (state, filter: string) => {
            const index = state.filters.indexOf(filter);

            if (index >= 0) {
                state.filters.splice(index, 1);
            }

            filterSerializer(state.filters);
        },
        clear_filters: (state) => {
            state.filters.splice(0);
            state.deldup.del = true;
            state.deldup.dup = true;

            delDupSerializer(state.deldup);
            filterSerializer(state.filters);
        },
        flip_del: (state) => {
            if (state.deldup.del && state.deldup.dup) {
                state.deldup.dup = false;
            } else if (state.deldup.del && !state.deldup.dup) {
                state.deldup.dup = true;
            } else if (!state.deldup.del && state.deldup.dup) {
                state.deldup.del = true;
                state.deldup.dup = false;
            }

            delDupSerializer(state.deldup);
        },
        flip_dup: (state) => {
            if (state.deldup.dup && state.deldup.del) {
                state.deldup.del = false;
            } else if (state.deldup.dup && !state.deldup.del) {
                state.deldup.del = true;
            } else if (!state.deldup.dup && state.deldup.del) {
                state.deldup.dup = true;
                state.deldup.del = false;
            }

            delDupSerializer(state.deldup);
        },
    },
});
